// App.js
import React, { useLayoutEffect } from 'react';
import { Box} from "@mui/material";
import ShipmentForm from "./widgets/ShipmentForm";

export default function AddShipmentScreen() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <Box sx={{ flex: 1 }} m={1}>
        <ShipmentForm>

        </ShipmentForm>
      </Box>
    </Box>


  )
}